export default "__VITE_PUBLIC_ASSET__c8ccf5b0__"